import { render } from "./manageRubric.vue?vue&type=template&id=f3103888"
import script from "./manageRubric.vue?vue&type=script&lang=js"
export * from "./manageRubric.vue?vue&type=script&lang=js"

import "./manageRubric.vue?vue&type=style&index=0&id=f3103888&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__